'use client';

import { useGetContent } from '@/lib/react-query/ContentQueries';
import { cn } from '@/lib/utils';
import type { JobType } from '@/types/content.types';

import OpenIndicator from '../OpenIndicator';

type Props = {
  className?: string;
  type?: JobType;
};

const Horaires = ({ className = '', type = 'piercing' }: Props) => {
  const { data: content } = useGetContent();
  const horaires = content?.horaire || [];

  return (
    <div
      className={cn(
        'rounded-md border bg-white/30 p-4',
        type === 'tattoo' ? 'border-emerald-400' : 'border-amber-200',
        className,
      )}
    >
      <h2 className="text-2xl font-semibold">Horaires d'ouverture</h2>
      <OpenIndicator />
      <ul role="list" className="divide-y divide-neutral-200">
        {horaires.map((horaire) => (
          <li key={horaire.day} className="flex justify-between gap-x-6 py-5">
            <div className="flex min-w-0 gap-x-4">
              <div className="min-w-0 flex-auto">
                <p className="text-sm leading-6 font-semibold text-gray-900">{horaire.day}</p>
              </div>
            </div>
            <div className="flex shrink-0 flex-col items-end">
              <p className="text-sm leading-6 text-gray-900">
                {horaire.is_open ? horaire.horaires : 'Fermé'}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Horaires;
